import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative flex min-h-[620px] w-full items-center overflow-hidden md:min-h-[720px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Towering%20mystic%20floating%20mountains%20shrouded%20in%20golden%20clouds%2C%20a%20majestic%20dragon%20silhouette%20coiling%20through%20the%20mist%2C%20chinese%20cultivation%20fantasy%20world%20at%20dawn%2C%20deep%20crimson%20and%20amber%20sky%2C%20traditional%20ink%20wash%20painting%20style%20fused%20with%20vibrant%20glow%2C%20epic%20mystical%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=hero-main&orientation=landscape"
          alt="东方玄幻的悬浮山脉与巨龙，斗罗大陆漫画追更背景"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/40 to-foreground-950/75"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pt-28 pb-20 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/10 px-4 py-1.5 text-xs font-medium tracking-wide text-accent-200">
            <i className="ri-fire-line" />
            斗罗大陆漫画 · 追更进度速览
          </span>
          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-background-50 md:text-5xl">
            更新到哪了、第几话、
            <span className="text-accent-300">完结没有？</span>
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
            这里汇总《斗罗大陆》漫画的最新剧情、追更话数与主线进度。从双生武魂觉醒到海神成神，追更前先看进度，不迷路。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/story"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              查看最新剧情
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/chapters"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/5 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/15"
            >
              追更话数进度
            </Link>
          </div>
        </div>
      </div>

      <a
        href="#progress"
        aria-label="向下浏览"
        className="absolute bottom-6 left-1/2 z-10 hidden -translate-x-1/2 flex-col items-center gap-1 text-background-100/80 transition-colors hover:text-background-50 md:flex"
      >
        <span className="text-xs tracking-widest">追更速览</span>
        <i className="ri-arrow-down-s-line text-xl animate-bounce" />
      </a>
    </section>
  );
}